module.exports = __webpack_public_path__ + "static/bg_all_collected_mob.9a2d426d.png";